import './App.css';
import Menu from './menu';
function App() {
  return (
    <div className="App">
      <Menu/>
    </div>
  );
}

export default App;
